<template>
	<v-container fluid grid-list-md class="pa-0 ma-0">
		<v-layout row wrap>
			<v-flex xs12>
				<v-parallax dark :src="tenant.cover_url" height="300">
					<v-overlay absolute color="secondary">
						<v-row align="center" justify="center">
							<v-col class="text-center" cols="12">
								<h1 class="text-h3 font-weight-thin mb-4">
									{{ tenant.name }}
								</h1>
								<h4
									class="subheading font-weight-normal"
									style="max-width: 800px; margin: auto"
									v-html="tenant.description"
								></h4>
							</v-col>
						</v-row>
					</v-overlay>
				</v-parallax>
			</v-flex>
			<v-flex xs12>
				<v-container grid-list-md class="container--box">
					<ShopOutletGrid :outlets="outlets"></ShopOutletGrid>
				</v-container>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import ShopOutletGrid from "@Shop/components/ShopOutletGrid.vue";
export default {
	props: ["data", "outlets"],
	data() {
		return {
			tenant: this.data,
		};
	},
	components: {
		ShopOutletGrid,
	},
};
</script>